import React, { useEffect, useState } from "react";
import salonbgc from "../../Images/salonbgc.png";
import { useTranslation } from "react-i18next";

export default function MPBlock1() {
  const { t, i18n } = useTranslation();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: windowWidth <= 1024 ? "200px" : "350px",
        backgroundImage: `url(${salonbgc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Optional overlay for better text readability */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h1
          style={{
            color: "white",
            fontSize: windowWidth <= 1024 ? "24px" : "48px",
            fontWeight: "bold",
            margin: 0,
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          }}
        >
          {t("BookYourAppointmentInSeconds")}
        </h1>
        <p
          style={{
            color: "white",
            fontSize: windowWidth <= 1024 ? "14px" : "20px",
            marginTop: "10px",
            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
          }}
        >
          {t("FindProfessionalBarbersAndSalons")}
        </p>
      </div>
    </div>
  );
}
